import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import BookingPage from "@/pages/BookingPage";
import AdminPage from "@/pages/AdminPage";
import AdminCalendarPage from "@/pages/AdminCalendarPage";
import AdminDaySummaryPage from "@/pages/AdminDaySummaryPage";
import AdminInvoicePage from "@/pages/AdminInvoicePage";
import LookupPage from "@/pages/LookupPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<BookingPage />} />
          <Route path="/lookup" element={<LookupPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/admin/calendar" element={<AdminCalendarPage />} />
          <Route path="/admin/day" element={<AdminDaySummaryPage />} />
          <Route path="/admin/invoice/:id" element={<AdminInvoicePage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </div>
  );
}

export default App;
